module.exports = __webpack_public_path__ + "img/map-index.bad32208.jpg";